import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPluginDataForDashboard } from "./selectors.js";
import { setDashboardPluginData } from "./actions.js";
/**
 * Custom hook that provides access to plugin data for a specific dashboard and plugin.
 * @param dashboardId - The ID of the dashboard.
 * @param pluginId - The ID of the plugin.
 * @returns A tuple containing the plugin data and a function to update the plugin data.
 */
export function useDashboardPluginData(dashboardId, pluginId) {
  var dispatch = useDispatch();
  var data = useSelector(store => getPluginDataForDashboard(store, dashboardId, pluginId));
  var setData = useCallback(newData => dispatch(setDashboardPluginData(dashboardId, pluginId, newData)), [dashboardId, pluginId, dispatch]);
  return [data, setData];
}
export default {
  useDashboardPluginData
};
//# sourceMappingURL=hooks.js.map